export const diceRoll = () => {
  const roll = Math.floor(Math.random() * 10 + 1);
  return roll;
};
